module.exports = __webpack_public_path__ + "static/media/545.832e3234.png";